import { render } from "./Pastelero.vue?vue&type=template&id=86037032"
import script from "./Pastelero.vue?vue&type=script&lang=js"
export * from "./Pastelero.vue?vue&type=script&lang=js"

import "./Pastelero.vue?vue&type=style&index=0&id=86037032&lang=css"

import exportComponent from "C:\\Users\\Fernando\\Desktop\\curso Innovaccion Virtual\\FrontEnd\\Practica5 VUE\\pasteleria-vuex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__